var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open && _vm.target
    ? _c(
        "div",
        {
          staticClass: "mq-heatmap-node-action-menu",
          style: { left: `${_vm.clampedLeft}px`, top: `${_vm.clampedTop}px` },
          attrs: {
            role: "menu",
            "aria-label": `Actions for ${_vm.targetLabel}`,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "mq-heatmap-node-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: { click: _vm.onToggleSelect },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isSelected ? "Deselect node(s)" : "Select node") +
                  " "
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }